import { useInfiniteQuery } from 'react-query';
import {
  getAdaptedFictionEditionComments,
  type GetAdaptedFictionEditionCommentsParams
} from '../../services/commentsAndLikeService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useGetAdaptedFictionEditionComments({
  adaptedFictionEditionId,
  params
}: {
  adaptedFictionEditionId: string;
  params: GetAdaptedFictionEditionCommentsParams;
}) {
  const perPage = params?.per_page ?? 10;

  return useInfiniteQuery({
    queryKey: [...SCENE_QUERY_KEYS.adaptedFictionEditionComments(adaptedFictionEditionId), perPage],
    queryFn: ({ pageParam = 1 }) =>
      getAdaptedFictionEditionComments({
        adaptedFictionEditionId,
        params: {
          ...params,
          page: pageParam,
          per_page: perPage
        }
      }),
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.meta?.pagination;
      if (!pagination) return undefined;
      if (pagination.currentPage >= pagination.totalPages) return undefined;
      return pagination.currentPage + 1;
    }
  });
}
